import { Box } from '@mui/material';
import { KitButton, KitCard } from '../common/MobileKit';
import { protoIcon } from '../common/ProtoIcon';
import { KitBanner, KitField, KitFormBar, KitSeg, KitSelect, KitStepper, KitTextarea, KitThumb } from '../common/MobileKitExtras';

/**
 * Reposição de estoque no shell mobile — `prototipos-mobile/produtos/repor.html`.
 * Só apresentação: valores, validação e envio vêm de `pages/products/Reposition.js`.
 */
const PackageIcon = protoIcon('package');
const AlertIcon = protoIcon('alert');

export default function MobileProductReposition({ formik, product, currentStock, minStock, loading, canConfirm, invalidSaida, afterValue, onCancel }) {
    const { values, touched, errors } = formik;
    const low = currentStock <= minStock;
    const qty = parseInt(values.new_quantity, 10) || 0;
    const setQty = (n) => formik.setFieldValue('new_quantity', n < 0 ? 0 : n);
    const qtyError = touched.new_quantity && errors.new_quantity;
    const typeError = touched.type_moviment && errors.type_moviment;

    return (
        <Box sx={{ fontSize: 14, lineHeight: 1.4 }}>
            <KitCard sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <KitThumb icon={PackageIcon} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box sx={{ fontWeight: 700 }}>{product.name || 'Produto'}</Box>
                    <Box sx={{ fontSize: 12.5, ...(low ? { color: '#b45309', fontWeight: 700 } : { color: 'text.disabled' }) }}>
                        Estoque atual: {currentStock} un · mín. {minStock}
                    </Box>
                </Box>
            </KitCard>

            <Box sx={{ mt: '16px' }} />

            <KitField label="Tipo de movimento" required help={typeError || undefined} error={Boolean(typeError)}>
                <KitSeg
                    options={[{ value: 'In', label: 'Entrada' }, { value: 'Out', label: 'Saída' }]}
                    value={values.type_moviment}
                    onChange={(v) => formik.setFieldValue('type_moviment', v)}
                />
            </KitField>

            <KitField label="Quantidade a repor" required help={qtyError || undefined} error={Boolean(qtyError)}>
                <Box sx={{ width: 'max-content' }}>
                    <KitStepper
                        value={(
                            <Box
                                component="input"
                                type="number"
                                inputMode="numeric"
                                name="new_quantity"
                                min={1}
                                value={values.new_quantity}
                                placeholder="0"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                aria-label="Quantidade"
                                sx={{ width: 36, border: 0, outline: 0, background: 'transparent', textAlign: 'center', fontWeight: 800, fontSize: 16, fontFamily: 'inherit', color: 'text.primary', p: 0, MozAppearance: 'textfield', '&::-webkit-outer-spin-button,&::-webkit-inner-spin-button': { WebkitAppearance: 'none', m: 0 } }}
                            />
                        )}
                        onMinus={() => setQty(Math.max(1, qty - 1))}
                        onPlus={() => setQty(qty + 1)}
                        minusDisabled={qty <= 1}
                    />
                </Box>
            </KitField>

            <KitField label="Fornecedor">
                <KitSelect value="" disabled aria-label="Fornecedor">
                    <option value="">{product.supplier_name || '—'}</option>
                </KitSelect>
            </KitField>

            <KitField label="Observação" help={errors.observations && touched.observations ? errors.observations : `${(values.observations || '').length}/100`} error={Boolean(touched.observations && errors.observations)}>
                <KitTextarea name="observations" value={values.observations} onChange={formik.handleChange} onBlur={formik.handleBlur} maxLength={100} />
            </KitField>

            {values.type_moviment && qty > 0 && (
                <KitBanner tone={invalidSaida ? 'danger' : 'info'} icon={AlertIcon} iconSize={18} title="Estoque após a movimentação">
                    {invalidSaida ? 'Quantidade maior que o estoque disponível.' : `${afterValue} un`}
                </KitBanner>
            )}

            <KitFormBar>
                <KitButton onClick={onCancel}>Cancelar</KitButton>
                <KitButton variant="primary" onClick={formik.handleSubmit} disabled={loading || !canConfirm}>
                    {loading ? 'Confirmando...' : 'Confirmar reposição'}
                </KitButton>
            </KitFormBar>
        </Box>
    );
}
